<ng-container *ngTemplateOutlet="(selectedDeliveryType$ | async) === deliveryType.Delivery ? delivery : pickup"></ng-container>

<ng-template #pickup>
  <div class="resto-select l-wrapper-push">
    <app-resto-select></app-resto-select>
  </div>
</ng-template>

<ng-template #delivery>
  @if (addressFieldSettings$ | async; as addressFieldSettings) {
    @if (!addressFieldSettings.useAddressFormatType) {
      @if (!addressFieldSettings.usesIndexSearch && !addressFieldSettings.useUaeAddressingSystem) {
        <app-full-address-step
          [isFullView]="isFullView"
          [formControl]="form"
        ></app-full-address-step>
      }
      @if (addressFieldSettings.usesIndexSearch) {
        <app-index-address-step [formControl]="form"></app-index-address-step>
      }
      @if (addressFieldSettings.useUaeAddressingSystem) {
        <app-zone-address-step [formControl]="form"></app-zone-address-step>
      }
    }
    @if (addressFieldSettings.useAddressFormatType) {
      <app-hint-address-step [isFullView]="isFullView" [formControl]="form"></app-hint-address-step>
    }
  }
</ng-template>
